import { useMutation } from '@src/query';


/**
 * Settings → Locations mutation hooks (T10). Each wraps the shared `useMutation`
 * engine with the injected-`queryClient` `mutateFn({ apiClient, queryClient })`
 * contract — the corelib query singleton is NOT imported here. Invalidation runs
 * inside `mutateFn`; the caller passes the locations-list `queryKey` it already
 * holds from `useLocationsQuery`, so the exact cache key is preserved unchanged.
 *
 * Mirrors `query/garage/useDonorMutations.js`.
 */

/** Create/update a location. Variables: `{ sellerId, locationId, payload,
 * queryKey }`. PATCHes when `locationId`, otherwise POSTs. */
function useLocationSaveMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, sellerId, locationId, payload, queryKey }) => apiClient
      .request({
        url: locationId
          ? `/sellers/${sellerId}/locations/${locationId}/`
          : `/sellers/${sellerId}/locations/`,
        method: locationId ? 'PATCH' : 'POST',
        payload,
      })
      .then((data) => queryClient.invalidateQueries({ queryKey }).then(() => data)),
    ...params,
  });
}


/** Mark a location as the org default. Variables: `{ sellerId, locationId, queryKey }`. */
function useLocationSetDefaultMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, sellerId, locationId, queryKey }) => apiClient
      .request({
        url: `/sellers/${sellerId}/locations/${locationId}/`,
        method: 'PATCH',
        payload: { is_default: true },
      })
      .then((data) => queryClient.invalidateQueries({ queryKey }).then(() => data)),
    ...params,
  });
}


/** Delete a location (blocked server-side when parts still live there).
 * Variables: `{ sellerId, locationId, queryKey }`. */
function useLocationDeleteMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, sellerId, locationId, queryKey }) => apiClient
      .request({ url: `/sellers/${sellerId}/locations/${locationId}/`, method: 'DELETE' })
      .then((data) => queryClient.invalidateQueries({ queryKey }).then(() => data)),
    ...params,
  });
}


export {
  useLocationDeleteMutation,
  useLocationSaveMutation,
  useLocationSetDefaultMutation,
};
